import * as React from "react";
import { useTranslation } from "react-i18next";
import { CoreConstants } from "../../../../core/models/constants/core.constants";
import { useToasterFacade } from "../../../facades/toaster.facade";
import Validators from "../../../helpers/validators";
import PrwcRoundedTextIconButton from "../buttons/PrwcRoundedTextIconButton";

const PrwcFileUpload: React.FC<any> = React.forwardRef(
  (props: any, ref: any) => {
    const {
      accept = CoreConstants.ACCEPT_EXCEL_OR_CSV_FILE,
      extensionsAllowed = CoreConstants.REGEX_EXCEL_FILE_EXTENSIONS,
      onUpload,
      data
    } = props;

    const toasterFacade = useToasterFacade();
    const { t } = useTranslation();

    const handleOnFileUpload = async (event: any) => {
      if (event) {
        const isValidFile = await Validators.isValidFile(
          event.target.files[0],
          extensionsAllowed
        );

        if (isValidFile) {
          onUpload(event.target.files[0]);
        } else {
          toasterFacade.showError(t("generic.msg.error.invalidFile"));
        }

        // This is to allow same file selection.
        event.target.value = null;
      }
    };

    return (
      <div className="prwc-file-upload">
        <input
          id="upload-file"
          type="file"
          ref={ref}
          style={{ display: "none" }}
          accept={accept}
          onChange={(e: any) => handleOnFileUpload(e)}
        ></input>

        <div>
          {data && (
            <div className="flex items-center">
              <div className="text-sm text-gray-500">{data && data?.name}</div>
              <div className="ml-2">
                <PrwcRoundedTextIconButton
                  onClick={() => onUpload(null)}
                  icon="pi pi-times"
                ></PrwcRoundedTextIconButton>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
);

export default PrwcFileUpload;
